import { connect } from 'react-redux';

import {
  getHelpArticles,
  getUnfilteredHelpArticles,
  getHelpCategory,
  getHelpCategories
} from 'features/help/category/actions';
import { getHelpStack } from 'features/help/actions';

import {
  setTopNavColorLight,
  setTopNavColorDark
} from 'features/navigation/header/actions';
import { setSelectedFilters } from 'features/filter/actions';

import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { palette, darkTheme } from 'theme';
import { MuiThemeProvider } from '@material-ui/core/styles';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import MetaTags from 'components/MetaTags';
import SwiftypeTags from 'components/SwiftypeTags';
import Container from 'components/Container';
import CircularLoader from 'components/CircularLoader';
import { PageHeaderGrid, PageHeaderText } from 'components/PageHeader';
import Filter from 'components/Filter';
import CustomSearchBox from 'components/Search/CustomSearchBox';

import HelpNav from './elements/HelpNav';
import HelpSearchProvider from '../elements/HelpSearchProvider';
import HelpContact from '../elements/HelpContact';

import { ARTICLES_PER_PAGE } from 'features/help/category/constants';

const WideContainer = styled.div`
  background-color: ${palette.grey[800]};
  margin-top: -64px;
  padding-top: 64px;
  width: 100%;
`;

const ArticlesContainer = styled(Container)`
  margin-top: 20px;
  margin-bottom: 40px;
`;

const ArticleTitleTypography = styled(Typography)`
  text-decoration: none;
  &:hover {
    color: ${palette.primary.main};
  }
`;

export class HelpCategory extends React.PureComponent {
  getCategoryContent = slug => {
    this.props.getHelpCategory(slug);
    this.props.getHelpArticles({
      filter: { categories: { $in_query: { slug: slug } } }
    });
    this.props.getUnfilteredHelpArticles(slug);
  };

  componentWillMount() {
    this.props.setTopNavColorLight();
  }

  componentDidMount() {
    this.props.setSelectedFilters({
      category: this.props.match.params.categorySlug
    });
    this.getCategoryContent(this.props.match.params.categorySlug);
    this.props.getHelpCategories();
    this.props.getHelpStack();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.match.params.categorySlug !==
      this.props.match.params.categorySlug
    ) {
      this.props.setSelectedFilters({
        category: this.props.match.params.categorySlug,
        categories_tags_product: null
      });
      this.getCategoryContent(this.props.match.params.categorySlug);
    }
    if (
      prevProps.selected_filters !== this.props.selected_filters &&
      this.props.selected_filters !== undefined
    ) {
      this.props.getHelpArticles({
        filter: this.props.filter_query
      });
    }
  }

  render() {
    const {
      category,
      categories,
      articles,
      all_articles,
      total_article_count,
      article_count,
      contact,
      getHelpArticles,
      loading,
      history
    } = this.props;

    const articleFilters = _.sortBy(
      _.uniqBy(_.flatMap(all_articles, 'categories_tags.product'), 'uid'),
      ['name']
    );
    return (
      <>
        <MetaTags stack={category} />
        <SwiftypeTags
          title={category.title}
          excerpt={category.description}
          body={category.description}
          stack={category}
        />
        <HelpSearchProvider>
          {category.title && categories.length > 0 && (
            <MuiThemeProvider theme={darkTheme}>
              <WideContainer>
                <Container>
                  <PageHeaderGrid container>
                    <Grid item xs={12} md={9}>
                      <Typography variant="overline" gutterBottom>
                        Help Center
                      </Typography>

                      <PageHeaderText
                        heading={category.title}
                        subheading={category.description}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <CustomSearchBox
                        autocompleteResults
                        searchAsYouType={false}
                        onSubmit={searchTerm => {
                          history.push(`/help?q=${searchTerm}`);
                        }}
                      />
                    </Grid>
                  </PageHeaderGrid>
                  <HelpNav
                    items={categories}
                    activeID={category ? category.uid : false}
                    backgroundColor={palette.grey[900]}
                    color="white"
                    showBack
                  />
                </Container>
              </WideContainer>
            </MuiThemeProvider>
          )}
          {articles && !loading && articleFilters.length > 1 ? (
            <ArticlesContainer>
              <Grid container spacing={16}>
                <Grid item xs={12}>
                  {articleFilters.length > 1 && (
                    <Filter
                      items={articleFilters}
                      filterKey="categories_tags_product"
                      matchKey="uid"
                      itemLabelKey="name"
                      variant="button"
                      showAll={true}
                    />
                  )}
                </Grid>
                {articles.map((article, idx) => (
                  <Grid item xs={12} sm={10} md={11} key={article.uid}>
                    <div>
                      <ArticleTitleTypography
                        to={article.url}
                        variant="h5"
                        component={Link}
                        gutterBottom
                      >
                        {article.title}
                      </ArticleTitleTypography>
                    </div>
                  </Grid>
                ))}

                {article_count < total_article_count && (
                  <Grid item xs={12}>
                    <Button
                      color="primary"
                      onClick={() => {
                        getHelpArticles({
                          limit: article_count + ARTICLES_PER_PAGE,
                          filter: this.props.filter_query
                        });
                      }}
                      size="large"
                      fullWidth
                      disableRipple
                    >
                      Load More (Showing {article_count} of{' '}
                      {total_article_count})
                    </Button>
                  </Grid>
                )}
              </Grid>
              {contact && (
                <HelpContact
                  text={contact.text}
                  button={contact.button}
                  align="center"
                />
              )}
            </ArticlesContainer>
          ) : (
            <CircularLoader />
          )}
        </HelpSearchProvider>
      </>
    );
  }
}

HelpCategory.propTypes = {
  articles: PropTypes.array
};

export default withRouter(
  connect(
    state => ({
      articles: state.helpCategory.articles,
      loading: state.helpCategory.loading,
      all_articles: state.helpCategory.all_articles,
      total_article_count: state.helpCategory.total_article_count,
      article_count: state.helpCategory.article_count,
      category: state.helpCategory.category,
      categories: state.helpCategory.categories,
      selected_filters: state.filters.selected_filters,
      filter_query: state.filters.filter_query,
      contact: state.helpLanding.stack.contact
    }),
    {
      getHelpArticles,
      getHelpCategory,
      getHelpCategories,
      getUnfilteredHelpArticles,
      getHelpStack,
      setSelectedFilters,
      setTopNavColorLight,
      setTopNavColorDark
    }
  )(HelpCategory)
);
